import { Container } from "@mui/system";
import ContactForm from "../components/contact/ContactForm";
import ContactInfo from "../components/contact/ContactInfo";

export default function Contact() {

  return (
    <Container sx={{ display: "flex", flexDirection: "column", mt: 10}} component={'div'}>
        <ContactForm />
        <ContactInfo />
    </Container>
  );
}
